import { call, all } from "redux-saga/effects";

import { fetchProduct } from "../actions/product/productSagas";
import { fetchGrade } from "../actions/grade/gradeSagas";
import { fetchSubject } from "../actions/subject/subjectSagas";
import { userLogOutInSaga, handleUpdateUserDetail } from "../actions/user/userSagas";
import { fetchSingleSimPage } from "../actions/singleSimPage/singleSimPageSagas";
import {
  fetchQuiz,
  fetchExerciseSim,
  fetchSingleSimDetail,
} from "../actions/singleSimDetail/singleSimDetailSagas";
import { fetchCart } from "../actions/cart/cartSagas";
import {
  loginListener,
  loginUserByTokenListener,
} from "../actions/login/loginSagas";
import { fetchConstat } from "../actions/constant/constantSagas";
import { fetchHashtag } from "../actions/hashtag/hashtagSagas";
import { handleUpdateUserUnReadMessage } from "../actions/userMessage/userMessageSagas";

export default function* rootSaga() {
  yield all([
    call(fetchProduct),
    call(fetchGrade),
    call(fetchSubject),
    call(userLogOutInSaga),
    call(fetchSingleSimPage),
    call(fetchQuiz),
    call(fetchExerciseSim),
    call(fetchSingleSimDetail),
    call(fetchCart),
    call(loginListener),
    call(loginUserByTokenListener),
    call(handleUpdateUserDetail),
    call(fetchConstat),
    call(fetchHashtag),
    call(handleUpdateUserUnReadMessage),
  ]);
}
